



















import { Vue, Prop, Component } from "vue-property-decorator";
import AButton from "./AButton.vue";

@Component({
    components: {
        AButton,
    },
})
export default class YearPicker extends Vue {
    @Prop() value!: number;
    @Prop() refYear!: number;
    @Prop() readonly rangeMin!: Date | null;
    @Prop() readonly rangeMax!: Date | null;
    @Prop() availableDates!: Date[] | null;
    @Prop({ type: Boolean }) hideNotAvailableDates!: boolean;

    private get years(): number[] {
        const ret: number[] = [];
        let startYear = this.refYear - 12;
        let endYear = this.refYear + 12;

        const minYear = this.rangeMin?.getFullYear() || 0;
        const maxYear = this.rangeMax?.getFullYear() || Infinity;
        startYear = Math.max(startYear, minYear);
        endYear = Math.min(endYear, maxYear);
        const diff = endYear - startYear;

        if (diff <= 24 && maxYear - minYear >= 24) {
            if (maxYear - endYear > 0) {
                endYear = Math.min(endYear + (23 - diff), maxYear);
            } else if (startYear - minYear > 0) {
                startYear = Math.max(startYear - (23 - diff), minYear);
            }
        }

        for (let y = startYear; y <= endYear; y++) {
            if (this.hideNotAvailableDates && this.isYearSelectable(y)) {
                ret.push(y);
            } else if (!this.hideNotAvailableDates) {
                ret.push(y);
            }
        }
        return ret;
    }

    private isYearSelectable(y: number) {
        let available = true;
        if (this.availableDates) {
            available = this.availableDates.some((date) => y === date.getFullYear());
        }
        return this.isInsideRange(y) && available;
    }

    private isInsideRange(y: number): boolean {
        if (!this.rangeMin && !this.rangeMax) {
            return true;
        } else {
            const lastDateOfYear = new Date(y, 11, 31).getDate();
            const firstDateOfYear = new Date(y, 0, 1).getDate();
            if (this.rangeMin && this.rangeMax) {
                const monthMin = this.rangeMin.getMonth();
                const monthMax = this.rangeMax.getMonth();
                const yearMax = this.rangeMax.getFullYear();
                const yearMin = this.rangeMin.getFullYear();
                const dayMin = this.rangeMin.getDate();
                const dayMax = this.rangeMax.getDate();
                if (
                    (y < yearMax && y > yearMin) ||
                    (y === yearMin && 11 > monthMin) ||
                    (y === yearMax && 0 < monthMax) ||
                    (y === yearMin && 11 === monthMin && dayMin < lastDateOfYear) ||
                    (y === yearMax && 0 === monthMax && dayMax > firstDateOfYear)
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.rangeMin) {
                    const yearMin = this.rangeMin.getFullYear();
                    const monthMin = this.rangeMin.getMonth();
                    const dayMin = this.rangeMin.getDate();
                    if (
                        y > yearMin ||
                        (y === yearMin && 11 > monthMin) ||
                        (y === yearMin && 11 === monthMin && dayMin < lastDateOfYear)
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (this.rangeMax) {
                    const yearMax = this.rangeMax.getFullYear();
                    const monthMax = this.rangeMax.getMonth();
                    const dayMax = this.rangeMax.getDate();
                    if (
                        y < yearMax ||
                        (y === yearMax && 0 < monthMax) ||
                        (y === yearMax && 0 === monthMax && dayMax > firstDateOfYear)
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
        return false;
    }
}
